import React from "react";

interface PaginationCompProps {
    pageNum: number;
    pageSize: number;
    totalCount: number;
    onPageChange: (newPageNum: number) => void;
}

const PaginationComp: React.FC<PaginationCompProps> = ({
    pageNum, pageSize, totalCount, onPageChange
}) => {
    return (
        <div className="d-flex justify-content-center mt-4">
            <nav>
                <ul className="pagination">
                    <li className={`page-item ${pageNum === 0 ? 'disabled' : 'bg-white text-dark'}`} title='First Page'>
                        <button className="page-link" onClick={() => onPageChange(0)} aria-label="First">
                            <i className="bi bi-chevron-double-left"></i>
                        </button>
                    </li>
                    <li className={`page-item ${pageNum === 0 ? 'disabled' : ''}`}>
                        <button
                            className="page-link"
                            onClick={() => onPageChange(pageNum - 1 < 0 ? 0 : pageNum - 1)}
                            disabled={pageNum === 0}
                            title="Previous Page"
                        >
                            <i className="bi bi-chevron-left"></i>
                        </button>
                    </li>
                    {Array.from({ length: Math.ceil(totalCount / pageSize) }, (_, index) => (
                        <li key={index} className={`page-item ${pageNum === index ? 'active bg-dark text-white' : 'bg-white text-dark'} `}>
                            <button className="page-link" onClick={() => onPageChange(index)}>
                                {index + 1}
                            </button>
                        </li>
                    ))}
                    <li className={`page-item ${pageNum === Math.ceil(totalCount / pageSize) - 1 ? 'disabled' : ''}`}>
                        <button
                            className="page-link"
                            onClick={() => onPageChange(Math.min(Math.ceil(totalCount / pageSize) - 1, pageNum + 1))}
                            disabled={pageNum === Math.ceil(totalCount / pageSize) - 1}
                            title="Next Page"
                        >
                            <i className="bi bi-chevron-right"></i>
                        </button>
                    </li>
                    <li className={`page-item ${pageNum === Math.ceil(totalCount / pageSize) - 1 ? 'disabled' : 'bg-white text-dark'}`} title='Last Page'>
                        <button className="page-link" onClick={() => onPageChange(Math.ceil(totalCount / pageSize) - 1)} aria-label="Last">
                            <i className="bi bi-chevron-double-right"></i>
                        </button>
                    </li>
                </ul>
            </nav>
        </div>
    );

};

export default PaginationComp;